import pdfIcon from '../../../assets/images/create-meeting/pdf.png';
import documentIcon from '../../../assets/images/section-menu/document.png';

/**
 * Get the appropriate icon for a document based on its file name or MIME type
 * @param {string} fileName - The file name (e.g., "document.pdf")
 * @param {string} mimeType - The MIME type (e.g., "application/pdf")
 * @returns {string} - Path to the icon image
 */
export function getDocumentIcon(fileName, mimeType) {
  // Check if it's a PDF by MIME type
  if (mimeType === 'application/pdf') {
    return pdfIcon;
  }

  // Check if it's a PDF by file extension
  if (fileName && fileName.toLowerCase().endsWith('.pdf')) {
    return pdfIcon;
  }

  // For all other document types (Word, Excel, PowerPoint, etc.), use generic document icon
  return documentIcon;
}

